import React from 'react'

const styles = {
  grid: {
    display: 'inline-block',
    border: '2px solid var(--color-primary)',
  },
  row: {
    display: 'flex',
  },
  cell: {
    width: '32px',
    height: '32px',
    border: '1px solid var(--color-primary)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    position: 'relative',
    background: '#fff',
  },
  cellBlack: {
    background: '#000',
    cursor: 'pointer',
  },
  cellSelected: {
    outline: '3px solid var(--color-accent)',
    outlineOffset: '-3px',
  },
  cellNumber: {
    position: 'absolute',
    top: '1px',
    left: '2px',
    fontSize: '9px',
    fontWeight: '700',
  },
  cellLetter: {
    fontSize: '16px',
    fontWeight: '700',
  },
}

export default function EditorGrid({
  grid,
  numberedCells,
  selectedCell,
  onCellClick,
  showLetters = true,
}) {
  if (!grid) return null

  return (
    <div style={styles.grid}>
      {grid.map((row, rowIdx) => (
        <div key={rowIdx} style={styles.row}>
          {row.map((cell, colIdx) => {
            const isSelected = selectedCell?.row === rowIdx && selectedCell?.col === colIdx
            const cellNum = numberedCells.cells[`${rowIdx}-${colIdx}`]

            return (
              <div
                key={colIdx}
                style={{
                  ...styles.cell,
                  ...(cell.isBlack ? styles.cellBlack : {}),
                  ...(isSelected ? styles.cellSelected : {}),
                }}
                onClick={() => onCellClick(rowIdx, colIdx)}
              >
                {cellNum && !cell.isBlack && (
                  <span style={styles.cellNumber}>{cellNum}</span>
                )}
                {!cell.isBlack && showLetters && (
                  <span style={styles.cellLetter}>{cell.letter}</span>
                )}
              </div>
            )
          })}
        </div>
      ))}
    </div>
  )
}
